 import { Component } from '@theme/component';
import { fetchConfig } from '@theme/utilities';



 class ExtraOption extends Component {
    static observedAttributes = ["checked"];
    requiredRefs = ["input"];
    #input=null;
    #form=null;
    #type=null;
    #name=null;
    #cookieDetail={};
    #cookie=null;
    constructor() {
        super();
    }

   
    #setCookieDetail=()=>{
        //this.#cookieDetail.url=location.href;
        this.#cookieDetail.name=`extraoption_${this.#input.name}`;
        
    }
    #setCookie=async ()=>{
        const value=this.#input.value;
        const expires=(new Date().getTime())+864e5;
        const setDetails={...this.#cookieDetail,expires,value};
        console.log(setDetails);
        return cookieStore.set(setDetails);
    }
     #init= async () =>{
        console.log("init extra option");
       this.#form=this.closest(".product-details").querySelector('form.shopify-product-form');
       this.#setCookieDetail();
       this.#cookie=await cookieStore.get(this.#cookieDetail);
       console.log(`${this.#input.name} ${this.#input.checked}`)
       if(this.#cookie===null && this.#input.checked ){
            this.#cookie=this.#setCookie();
       }
       if(this.#cookie!=null && !this.#input.checked && this.#cookie.value===this.#input.value){
        console.log("set input value to cookie value");
        this.#input.checked=true;
       }
       if(this.#form) this.#form.addEventListener("submit",this.#onFormSubmit);
    }
    #onClick=(event)=>{
        console.log(`click ${this.#name}`);
        this.#cookie=this.#setCookie(this.#input.value);
        this.#input.checked=true;
        event.preventDefault();
    }
     #onChange=(event)=>{
        console.log(`click ${this.#name}`);
        
        if(this.#cookie.value!==this.#input.value){
            console.log(`value not set by customer`);
            return false;
        };
        event.preventDefault();
    }
    #onFormSubmit=async ()=>{
        if(!this.#input.checked || this.#input.dataset.varid==="") return;     
        const formData = new FormData();
        formData.set('id', this.#input.dataset.varid);
        formData.set('form_type', "product");
        formData.set('product-id', this.#input.dataset.prodid);
        formData.set('utf8', "1");
        formData.set('quantity', "1");

        const fetchCfg = fetchConfig('javascript', { body: formData });
        fetch(Theme.routes.cart_add_url, {
        ...fetchCfg,
        headers: {
            ...fetchCfg.headers,
            Accept: 'text/html',
        },
        })
        .then((response) => response.json())
        .then(async (response) => {
        if (response.status) {
            console.log(response.status)
            return;
        } 
        })
        .catch((error) => {
        console.error(error);
        })
        .finally(() => {
        if (event) {
            
        }
        });  


    }
    connectedCallback() {
        super.connectedCallback();
        //this.#enddateStr=this.getAttribute("enddate");
        this.#input = this.refs.input||this.querySelector('[ref="input"]');
        this.#type=this.#input.type;
        this.#name=this.#input.name;
        this.addEventListener("click",this.#onClick);
        
        this.addEventListener("change",this.#onChange);
        this.#init();
    }

    disconnectedCallback() {
    // Disconnect all the event listeners
 
    }
    attributeChangedCallback(name, oldValue, newValue) {
        console.log(`attributeChangedCallback(${name}, ${oldValue}, ${newValue})`)
    }

}

if (!customElements.get('extra-option')) {
  customElements.define('extra-option', ExtraOption);
}